<template>
  <el-form-item
    :label="label"
    class="billing_ym"
    :prop="prop"
    :rules="rules"
  >
    <el-select
      v-model="billingYm"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
      :clearable="false"
      :filterable="false"
      :actualprop="true"
    >
      <el-option v-if='mode !== "this"' label="" value="" />
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <!-- 追加実績年月の表示 -->
    <el-label v-if="actualprop !== false && mode !== 'search'&& value !== undefined && value !== ''  " class = "actualYmlabel" >
    実績年月：{{ actualYm }}
    </el-label>
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {},
  model: {
    event: 'change'
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '請求年月'
    },
    prop: {
      type: String,
      default: 'billing_ym'
    },
    // 追加実績年月の表示
    actualprop: {
      type: Boolean,
      default: false
    },
    // 追加実績年月の表示
    actualmode: {
      type: Number,
      default: 1
    },
    mode: {
      type: String,
      default: 'search'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    initialize: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      options: [],
      optionsOriginal: [],
      placeholder: '',
      // 追加実績年月の表示
      actualYm: ''
    }
  },
  computed: {
    billingYm: {
      get () {
        return this.value
      },
      set (billingYm) {
        // 追加実績年月の表示
        this.dispactualYm(billingYm)
        this.$emit('change', billingYm)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'change'))
          }
        }
        return rules
      }
    }
  },
  async mounted () {
    const billingYm = await this.loadBillingYm()
    const billingYmSet = [...new Set(billingYm.map((x) => x.code_value))]
    this.options = billingYmSet.map((x) => { return { value: x, label: x } })
    this.optionsOriginal = billingYmSet
  },
  methods: {
    async loadBillingYm () {
      if (this.initialize) {
        // デフォルト請求年月取得
        // - 当月確定データ有:最新当月確定年月+1ヵ月
        // - 当月確定データ無:システム年月
        var defaultBillingYm = await this.getBillingYmFromRDS()
        // vue-session-key更新
        this.$session.set('latestBillingYM', defaultBillingYm)
        var dt = new Date(defaultBillingYm.substr(0, 4) + '/' + defaultBillingYm.substr(4, 2) + '/1')

        // 請求年月リストを作成
        var ym = new Date()
        // 検索用:デフォルト請求年月+1ヵ月から-12ヵ月
        var billingYmForSearch = []
        for (let i = 1; i >= -12; i--) {
          ym = new Date(dt.getFullYear(), dt.getMonth() + i, dt.getDate())
          billingYmForSearch.push({ key: String(i), code_value: String(ym.getFullYear()) + String(ym.getMonth() + 1).padStart(2, '0') })
        }
        // 検索用Storageセット
        sessionStorage.setItem('billingYmForSearch', JSON.stringify(billingYmForSearch))

        // 編集用:デフォルト請求年月+0ヵ月～+1ヵ月
        var billingYmForEdit = []
        for (let i = 0; i <= 1; i++) {
          ym = new Date(dt.getFullYear(), dt.getMonth() + i, dt.getDate())
          billingYmForEdit.push({ key: String(i), code_value: String(ym.getFullYear()) + String(ym.getMonth() + 1).padStart(2, '0') })
        }
        // 編集用Storageセット
        sessionStorage.setItem('billingYmForEdit', JSON.stringify(billingYmForEdit))

        // 限定用:デフォルト請求年月限定
        var billingYmForThis = []
        for (let i = 0; i <= 0; i++) {
          ym = new Date(dt.getFullYear(), dt.getMonth() + i, dt.getDate())
          billingYmForThis.push({ key: String(i), code_value: String(ym.getFullYear()) + String(ym.getMonth() + 1).padStart(2, '0') })
        }
        // 限定用Storageセット
        sessionStorage.setItem('billingYmForThis', JSON.stringify(billingYmForThis))

        // 請求照会用:デフォルト請求年月+0ヵ月から-12ヵ月
        var billingYmForInvoice = []
        for (let i = 0; i >= -12; i--) {
          ym = new Date(dt.getFullYear(), dt.getMonth() + i, dt.getDate())
          billingYmForInvoice.push({ key: String(i), code_value: String(ym.getFullYear()) + String(ym.getMonth() + 1).padStart(2, '0') })
        }
        // 請求照会用Storageセット
        sessionStorage.setItem('billingYmForInvoice', JSON.stringify(billingYmForInvoice))
      }
      // 請求年月初期値セット（更新）
      this.billingYm = this.getDefaultBillingYm()
      // console.log(this.$session.get('latestBillingYM'))
      // 検索の場合:billingYmForSearch
      if (this.mode === 'search') {
        return JSON.parse(sessionStorage.getItem('billingYmForSearch'))
      // 編集の場合:billingYmForThis
      } else if (this.mode === 'this') {
        return JSON.parse(sessionStorage.getItem('billingYmForThis'))
      // 請求照会の場合:billingYmForInvoice
      } else if (this.mode === 'invoice') {
        return JSON.parse(sessionStorage.getItem('billingYmForInvoice'))
      // 上記以外の場合:billingYmForEdit
      } else {
        return JSON.parse(sessionStorage.getItem('billingYmForEdit'))
      }
    },
    // 追加実績年月の表示
    async dispactualYm (billingYm) {
      // console.log(this.value)
      // 選択された請求年月(billingYm)をDate型に変換
      var dt = new Date(billingYm.substr(0, 4) + '/' + billingYm.substr(4, 2) + '/1')
      // 実績年月は請求年月の-1ヵ月OR-2ヵ月
      dt.setMonth(dt.getMonth() - this.actualmode)
      // 実績年月リストを作成
      this.actualYm = String(dt.getFullYear()) + String(dt.getMonth() + 1).padStart(2, '0')
    }
  }
}
</script>

<style lang="scss" scoped>
.billing_ym {
  ::v-deep .el-form-item__content {
    width: 8em;
  }
}
.actualYmlabel {
  float: left;
}
</style>
